import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslocoService } from '@jsverse/transloco';

import { DialogService } from 'primeng/dynamicdialog';
import { UnitPermissionsModel } from './share-panel.d';
import { GenericAlertComponent } from './generic-alert/generic-alert.component';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  constructor(
    private messageService: MessageService,
    private translocoService: TranslocoService,
    private dialogService: DialogService,
  ) { }

  public showPrivacyChangeMessage(settings: UnitPermissionsModel, lastSettings: UnitPermissionsModel): void {
    const isPublic = settings.privacyLevel.level === 'PUBLIC';
    const isPrivate = ['PRIVATE', 'CUSTOM'].includes(settings.privacyLevel.level);

    const wasPublic = lastSettings.privacyLevel.level === 'PUBLIC';
    const wasPrivate = ['PRIVATE', 'CUSTOM'].includes(lastSettings.privacyLevel.level);

    if (isPrivate && !wasPrivate) {
      this.messageService.add({
        severity: 'error',
        life: 5000,
        summary: this.translocoService.translate('sharePanel.messages.private.title'),
        detail: this.translocoService.translate('sharePanel.messages.private.details'),
      });
    } else if (isPublic && !wasPublic) {
      this.messageService.add({
        severity: 'info',
        life: 5000,
        summary: this.translocoService.translate('sharePanel.messages.public.title'),
        detail: this.translocoService.translate('sharePanel.messages.public.details'),
      });
    }
  }

  public showServerErrorDialog() {
    this.dialogService.open(GenericAlertComponent, {
      showHeader: false,
    });
  }
}
